import React from "react";

export interface PaymentSummarySectionProps {
  title: string;
  children: React.ReactNode;
}

const PaymentSummarySection: React.FC<PaymentSummarySectionProps> = ({ title, children }) => (
  <div className="xgs-payment-admin__summary__row">
    <div className="xgs-payment-admin__summary__row__title">{title}</div>
    <div className="xgs-payment-admin__summary__row__tiles">{children}</div>
  </div>
);

export default PaymentSummarySection;
